const especieEmoji = { perro: '🐶', gato: '🐱', ave: '🐦', conejo: '🐰', pez: '🐟', reptil: '🦎', otro: '🐾' }

function MascotaCard({ mascota, onEliminar }) {
  return (
    <div style={estilos.card}>
      <div style={estilos.header}>
        <div style={estilos.headerIzq}>
          <span style={estilos.emoji}>{especieEmoji[mascota.especie] || '🐾'}</span>
          <div>
            <div style={estilos.nombre}>{mascota.nombre}</div>
            <div style={estilos.especie}>{mascota.raza ? `${mascota.especie} · ${mascota.raza}` : mascota.especie}</div>
          </div>
        </div>
        <button onClick={() => onEliminar(mascota.id)} style={estilos.btnEliminar}>Eliminar</button>
      </div>
      {mascota.descripcion && <p style={estilos.descripcion}>{mascota.descripcion}</p>}
      {mascota.cuidador_nombre && (
        <div style={estilos.cuidador}>
          <span style={estilos.cuidadorLabel}>👤 Cuidador:</span>
          <span style={estilos.cuidadorNombre}>{mascota.cuidador_nombre}</span>
          {mascota.cuidador_email && <span style={estilos.cuidadorEmail}>{mascota.cuidador_email}</span>}
          {mascota.cuidador_telefono && <span style={estilos.cuidadorEmail}>{mascota.cuidador_telefono}</span>}
        </div>
      )}
      {mascota.instrucciones && (
        <div style={estilos.instrucciones}>
          <div style={estilos.instruccionesLabel}>Instrucciones:</div>
          <p style={estilos.instruccionesTexto}>{mascota.instrucciones}</p>
        </div>
      )}
    </div>
  )
}

const estilos = {
  card: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '16px 20px', marginBottom: '10px', border: '1px solid #E8E0D5' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' },
  headerIzq: { display: 'flex', alignItems: 'center', gap: '12px' },
  emoji: { fontSize: '28px' },
  nombre: { fontSize: '16px', fontWeight: '700', color: '#2C1810' },
  especie: { fontSize: '12px', color: '#8B6F47', textTransform: 'capitalize' },
  btnEliminar: { backgroundColor: 'transparent', border: '1px solid #E8E0D5', color: '#8B6F47', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' },
  descripcion: { fontSize: '13px', color: '#5C4033', marginBottom: '10px', lineHeight: '1.5' },
  cuidador: { display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', backgroundColor: '#FAF8F5', padding: '8px 12px', borderRadius: '8px', marginBottom: '8px' },
  cuidadorLabel: { fontSize: '12px', color: '#8B6F47', fontWeight: '600' },
  cuidadorNombre: { fontSize: '13px', color: '#2C1810', fontWeight: '500' },
  cuidadorEmail: { fontSize: '12px', color: '#8B6F47' },
  instrucciones: { backgroundColor: '#F0EAE0', padding: '10px 12px', borderRadius: '8px' },
  instruccionesLabel: { fontSize: '12px', fontWeight: '600', color: '#2C1810', marginBottom: '4px' },
  instruccionesTexto: { fontSize: '13px', color: '#5C4033', lineHeight: '1.6', margin: 0 },
}

export default MascotaCard